exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-benchmarks-select[data-v-516b46ac] {\n  width: 250px;\n}\n.stop-button[data-v-516b46ac] .vue-ui-icon {\n  border-radius: 50%;\n  -webkit-filter: drop-shadow(0 0 3px rgba(255,0,0,0.4));\n          filter: drop-shadow(0 0 3px rgba(255,0,0,0.4));\n  animation: pulse-data-v-516b46ac 3s linear infinite;\n}\n.stop-button[data-v-516b46ac] .vue-ui-icon svg {\n  fill: #f00 !important;\n}\n.benchmark-duration[data-v-516b46ac] {\n  margin-left: 32px;\n}\n@keyframes pulse-data-v-516b46ac {\n0% {\n    opacity: 1;\n}\n50% {\n    opacity: 0.5;\n}\n100% {\n    opacity: 1;\n}\n}\n", ""]);

// exports
